import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export interface impersonateData {
  toEmailAddress: string;
  token: string;
}

export interface AuthenticationResponse {
  id: string;
  accessToken: string;
  name: string;
  refreshToken: string;
  version: string;
  status: string;
}


export const impersonateApi = createApi({
  reducerPath: "impersonateApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_BFF_WEB_URL, credentials: "include" }),
  endpoints: (build) => ({
    postImpersonate: build.mutation<AuthenticationResponse, impersonateData>({
      query: (data: impersonateData) => ({
        url: "/Account/impersonate-user",
        method: "POST",
        headers: {
          'Authorization': `Bearer ${data.token}`,
        },
        body: { toEmailAddress: data.toEmailAddress, token: data.token },
      }),
    }),
  }),
});

export const { usePostImpersonateMutation } = impersonateApi;
